import type { Claims } from "./oidc";

/**
 * 3.143 (the sponsor, 2026-10-11: "no-org accounts go to /platform ... no
 * platform admin can see tenets dashboard"): an account that belongs to NO
 * organisation is a platform operator, and never sees tenant pages.
 *
 * The signal is the token's own `org_id`. ADR-048 derives it from
 * organisation membership (the `organization` scope), so a token without it is
 * an account with no organisation. It adds no request and probes no admin
 * route: 2.968 rejected telling an operator from a tenant user by
 * permissions. Only a signed-in session whose claims could be read is judged.
 * Without an identity provider (the mock console) there is no token, and
 * nothing changes.
 */
export function belongsToNoOrganisation(status: string, claims: Claims | undefined): boolean {
  return status === "authenticated" && claims !== undefined && !claims.org_id;
}

/** The account's name from its token (name, then username, then email), for an account with no tenant session. */
export function claimsDisplayName(claims: Claims | undefined): string | undefined {
  return claims?.name?.trim() || claims?.preferred_username?.trim() || claims?.email?.trim() || undefined;
}

/** Up to two initials from a name or an email ("dev-user@hibir.et" reads "DU"). */
export function initialsOf(name: string): string {
  const parts = name.split(/[\s@._-]+/).filter(Boolean);
  return `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}`.toUpperCase() || "?";
}
